import styled from 'styled-components';

export const Header = styled.div`
  padding: 50px 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(0, 0, 1, 1));

  img{
    margin-top: -40px;
    position: absolute;
    opacity: 0.4;
    right: 0;
  }
`;

export const Title = styled.h1`
  text-transform: uppercase;
  font-size: 10rem;
  width: 80%;
  opacity: 0.1;
  color: rgba(102, 102, 102, 1);
`;

export const Subtitle = styled.h2`
  font-size: 2.5em;
  color: rgba(234, 11, 42, 1);
  width: 80%;
  margin-top: -52px;
`;